import { useState } from 'react';

/**
 * "Active Only" report preference. Defaults to ON so every report opens short —
 * inactive accounts and zero-balance rows hidden. Unchecking is per report view:
 * each report opens checked again, and the user unchecks when they want to see
 * everything.
 */
export function useActiveOnly(): [boolean, (v: boolean) => void] {
  return useState<boolean>(true);
}

/** Checkbox that hides inactive accounts and zero-balance rows from a report. */
export function ActiveOnlyToggle({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (v: boolean) => void;
}) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 13,
        cursor: 'pointer',
        userSelect: 'none',
      }}
      title="Hide accounts with a zero balance (accounts that carry a balance always show, so the report stays in balance)"
    >
      <input type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} />
      Active only
    </label>
  );
}
